import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const DSAModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Importance and fundamentals of algorithms and data structures', path: '/dsa-m1-s1' },
      { name: 'Types of asymptotic notations and orders of growth', path: '/dsa-m1-s2' },
      { name: 'Algorithm efficiency, best case, worst case, average case', path: '/dsa-m1-s3' },
      { name: 'Analysis of non-recursive and recursive algorithms', path: '/dsa-m1-s4' },
      { name: 'Asymptotic analysis for recurrence relation: Iteration Method, Substitution Method, Master Method, Recursive Tree Method', path: '/dsa-m1-s5' }
    ],
    'Module 2': [
      { name: 'Arrays: 1D and 2D array', path: '/dsa-m2-s1' },
      { name: 'Stacks and it’s applications', path: '/dsa-m2-s2' },
      { name: 'Tower Of Hanoi', path: '/dsa-m2-s3' },
      { name: 'Queue: Different types and Applications', path: '/dsa-m2-s4' },
      { name: 'List: Singly linked lists, Doubly linked lists, Circular linked lists & Applications: Polynomial Manipulation', path: '/dsa-m2-s5' }
    ],
    'Module 3': [
      { name: 'Searching Algorithms', path: '/dsa-m3-s1' },
      { name: 'Insertion Sort & Selection Sort', path: '/dsa-m3-s2' },
      { name: 'Bubble Sort', path: '/dsa-m3-s3' },
      { name: 'Merge Sort', path: '/dsa-m3-s4' },
      { name: 'Quick Sort', path: '/dsa-m3-s5' }
    ],
    'Module 4': [
      { name: 'Binary Tree', path: '/dsa-m4-s1' },
      { name: 'Binary Search Trees', path: '/dsa-m4-s2' }
    ],
    'Module 5': [
      { name: 'Graphs Terminology', path: '/dsa-m5-s1' },
      { name: 'Minimum Spanning Tree,Dijkstra Algorithm', path: '/dsa-m5-s2' }
    ],
    'Module 6': [
      { name: 'Hash functions', path: '/dsa-m6-s1' },
      { name: 'Closed hashing', path: '/dsa-m6-s2' }
    ],
    'Module 7': [
      { name: 'Heaps and AVL trees', path: '/dsa-m7-s1' },

    ]
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Data Structures and Algorithms</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] && subtopicsData[module].length > 0 ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-DSAModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Coming Soon...</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DSAModules;
